import React from "react";
import { SocialLink } from "./SocialLink";
import styles from "./Footer.module.scss";
import { NavigationLink } from "./NavigationLink";
import { useNavigate } from "react-router-dom";
import copyright from "../../../images/copy.png";
const socialLinks = [
  {
    name: "TWITTER",
    iconSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/0cf7ba3c9c3401efcec7f8c67150b3a80db53ac0e5b1638729d3f5b86291b898?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
  },
  {
    name: "INSTAGRAM",
    iconSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/0cf7ba3c9c3401efcec7f8c67150b3a80db53ac0e5b1638729d3f5b86291b898?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
  },
  {
    name: "REDDIT",
    iconSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/0cf7ba3c9c3401efcec7f8c67150b3a80db53ac0e5b1638729d3f5b86291b898?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
  },
  {
    name: "FACEBOOK",
    iconSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/0cf7ba3c9c3401efcec7f8c67150b3a80db53ac0e5b1638729d3f5b86291b898?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
  }
];

const navLinks = ["HOME", "ABOUT", "CONTACT US"];

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.footerContainer}>
      <footer className={styles.footer}>
        <div className={styles.content}>
          <div className={styles.branding}>
            <div className={styles.logo}>TROAK</div>
            <div className={styles.tagline}>troak - interactive stories</div>
          </div>
          <div className={styles.navigation}>
            <div className={styles.exploreSection}>
              <div className={styles.sectionTitle}>EXPLORE</div>
              <nav className={styles.navLinks}>
                {navLinks.map((link, index) => (
                  <NavigationLink key={index} text={link} />
                ))}
              </nav>
            </div>
            <div className={styles.socialSection}>
              <div className={styles.sectionTitle}>follow US</div>
              <div className={styles.socialLinks}>
                {socialLinks.map((link, index) => (
                  <SocialLink key={index} {...link} />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            <div><img src={copyright} alt="copyright" className={styles.copyrightIcon} /></div>
            <div className={styles.copyrightText}> - Endroza games private limited 2024. All rights reserved.</div>
          </div>
          <div className={styles.legalLinks}>
            <div className={styles.privacy} onClick={() => navigate('/tnc')}>Terms and condition</div>
            <div className={styles.privacy} onClick={() => navigate('/privacy-policy')}>privacy policy</div>
          </div>
        </div>
      </footer>
    </div>
  );
};
